// import './assets/main.css'
import App from './App.vue'
import { createApp } from 'vue'
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import { definePreset } from '@primevue/themes';
import { primeVueConfiguration } from '../../../js/utils/index.js'

const app = createApp(App)
// Globally register the component
app.config.globalProperties.window = window;
app.use(PrimeVue, primeVueConfiguration(Aura, definePreset))
app.mount('#building-detail-vue')
